export const MAX_OFFERS = 4;

export const URGENT_BONUS_PCT = 0.25;

const HOUR_MS = 60 * 60 * 1000;
const MINUTE_MS = 60 * 1000;

export const URGENT_DURATIONS_MS: readonly number[] = [4 * HOUR_MS, 12 * HOUR_MS, 24 * HOUR_MS];

/** Random real-time gap between one urgent offer ending and the next appearing. */
export const URGENT_COOLDOWN_MIN_MS = 3 * MINUTE_MS;
export const URGENT_COOLDOWN_MAX_MS = 10 * MINUTE_MS;
